import React from 'react';

import SmallPulse from '../../components/Loader/smallPulse';
import CLazyImg from '../../components/LazyImage';

const BbNewCoinImg = React.memo(
	({ className, height, src, width, alt, rootselector, isExcl, newCoin }) => (
		<div
			className={className}
			style={{
				height: typeof height !== 'undefined' ? `${height}px` : 'auto',
			}}
		>
			<div className="flex items-start pr-2 relative">
				<CLazyImg
					src={src}
					width={width}
					height={height}
					alt={alt}
					rootselector={rootselector}
				/>
				{isExcl && (
					<div className="bb-exclusive">
						<div
							className="bb-exclusive__wrapper"
							data-text="EXCLUSIVE ON BITBNS"
						/>
					</div>
				)}
				{newCoin && (
					<SmallPulse
						style={{
							height: '5px',
							width: '5px',
						}}
						className="text-pastelRed"
					/>
				)}
			</div>
		</div>
	)
);

export default BbNewCoinImg;
